<footer *ngIf="!isCommercialization" class="main-footer margin-5">
    <strong>Copyright &copy; {{currentYear}} <a href="#">Petronas Digital Sdn Bhd</a>.</strong>
    All rights reserved.
    <div class="float-right d-none d-sm-inline-block">
      <!-- <b>Version</b> 1.0 -->
    </div>
</footer>

<footer *ngIf="isCommercialization" class="main-footer margin-5">
  <strong>Copyright &copy; {{currentYear}} <a href="#">Pipeline Of The Future</a>.</strong>
  All rights reserved.
  <div class="float-right d-none d-sm-inline-block">
    <!-- <b>Version</b> 1.0 -->
  </div>
</footer>